globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.SecondaryNavigation = (function() {

  function SecondaryNavigation() {
    this.$secondaryNavigation = $('.secondary-navigation');
    this.init();
  }

  SecondaryNavigation.prototype = {
    init: function(){
      // Toggle active link on click for reactive behavior
      this.$secondaryNavigation.on('click', '.secondary-navigation-sections > ul > li > a', function() {
        var $this = $(this),
            $li   = $this.parent();

        if($li.hasClass('has-sub-ul')) return;

        $li.addClass('active');
      });

      // Switch member
      this.$secondaryNavigation.on('click', '.secondary-navigation-header-members.dropdown-menu a', function(){
        var $this = $(this),
            labelSelector = '[data-type="label"]',
            subLabelSelector = '[data-type="sublabel"]',
            label = $this.find(labelSelector).text(),
            subLabel = $this.find(subLabelSelector).text();

        $this.closest('.secondary-navigation-header').
        find('.secondary-navigation-header-member').
        find(labelSelector).text(label).end().
        find(subLabelSelector).text(subLabel);
      });
    }
  }

  return SecondaryNavigation;

})();
